/* eslint-disable eag/no-css-property */
import {css, keyframes} from 'styled-components';

import {isNilOrEmpty} from 'ramda-adjunct';

import {chatAgentApi} from '@dms/api/core';
import {useGetCurrentUserInfoQuery} from '@dms/api/customer';

interface CustomerChatIndicatorProps {
  conversationId: string;
  isTyping: boolean;
}

export function CustomerChatIndicator(props: CustomerChatIndicatorProps) {
  const {data: userInfo} = useGetCurrentUserInfoQuery();
  const currentUserId = userInfo?.id || '';

  const eventsQuery = chatAgentApi.useGetAgentEventsQuery(
    {
      conversationId: props.conversationId,
    },
    {skip: isNilOrEmpty(props.conversationId)}
  );

  const myUnreadEvents = eventsQuery.data?.filter(
    (event) => !event.readBy.some((readBy) => readBy.user.externalUserId === currentUserId)
  );

  if (myUnreadEvents?.length) {
    return (
      <div
        css={css`
          width: ${({theme}) => theme.getSize(2)};
          height: ${({theme}) => theme.getSize(2)};
          border-radius: ${({theme}) => theme.radii.circular};
          background: ${({theme}) => theme.colors.palettes.red[50][100]};
          flex-shrink: 0;
          position: absolute;
          top: 0;
          right: 0;
          margin: ${({theme}) => theme.getSize(1)};
        `}
      />
    );
  }

  if (props.isTyping) {
    return (
      <div
        css={css`
          width: ${({theme}) => theme.getSize(2)};
          height: ${({theme}) => theme.getSize(2)};
          border-radius: ${({theme}) => theme.radii.circular};
          background: ${({theme}) => theme.colors.palettes.neutral[50][100]};
          flex-shrink: 0;
          position: absolute;
          top: 0;
          right: 0;
          margin: ${({theme}) => theme.getSize(1)};
          animation: ${pulseAnimation};
        `}
      />
    );
  }

  return null;
}

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(0);
    opacity: 0.5;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const pulseAnimation = css`
  ${pulse} 0.75s ease-in-out infinite;
`;
